var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 36,
    viewBox: "0 0 36 36",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 36,
    rx: 8,
    width: 36
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 36,
    rx: 8,
    width: 36
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.51115 22.6778h7.45215c.0502 0 .0928.0431.0928.094v2.4467c0 .0509-.0426.094-.0928.094h-10.68294c-.0503 0-.09286-.0431-.09286-.094v-14.0152c0-.0509.04256-.0939.09286-.0939h10.41974c.0503 0 .0929.043.0929.0939v2.4468c0 .0509-.0426.094-.0929.094h-7.18895c-.0503 0-.09286.043-.09286.0939v8.738c0 .0509.04256.094.09286.094zm-.23989-5.8449h6.56994c.0503 0 .0928.0431.0928.094v2.3645c0 .0509-.0425.094-.0928.094h-6.56994c-.0503 0-.09286-.0431-.09286-.094v-2.3645c0-.0509.04256-.094.09286-.094z",
    fill: "#4318ff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#131939"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.9717 11.1094h-2.9445c-.0513 0-.0929.042-.0929.0939v14.0152c0 .0519.0416.094.0929.094h2.9445c.0512 0 .0928-.0421.0928-.094v-14.0152c0-.0519-.0416-.0939-.0928-.0939z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.9851 25.3125c.0774 0 .12-.0861.0774-.1488l-3.0334-4.4042s.0193-.0078.0271-.0117c.9092-.4072 1.6095-.9905 2.1048-1.7539s.7429-1.6756.7429-2.7286c0-1.0531-.2476-1.9888-.7429-2.76-.4953-.7713-1.1956-1.3624-2.1048-1.7774-.9093-.411-1.9927-.6185-3.2502-.6185h-2.5227c-.0503 0-.0929.043-.0929.0939v2.486c0 .0509.0426.0939.0929.0939h2.3447c1.0022 0 1.7528.2153 2.248.6499.4953.4345.7429 1.0413.7429 1.8282s-.2476 1.3781-.7429 1.8165c-.4952.4385-1.242.6577-2.248.6577h-2.3447c-.0503 0-.0929.0431-.0929.094v2.4272c0 .0509.0426.094.0929.094h2.5227.1509l2.6698 3.9187c.0193.0274.0464.0431.0774.0431z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.77c99d3d739b74a3062f866e5ac2a47d.svg";
export { ForwardRef as ReactComponent };